import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TextField } from '@nutrien/cxp-components';
import React from 'react';

interface Props {
  updateUserName: (userName: string) => void;
  userNameError: string;
  updateUserNameError: (userNameError: string) => void;
}

const useStyles = makeStyles({
  space: {
    margin: '16px 0px 10px 0px',
  },
});

const SignUpFlowUsername = ({ updateUserName, userNameError, updateUserNameError }: Props) => {
  const classes = useStyles();

  const handleChange = (event: React.FocusEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    updateUserNameError('');
    updateUserName(value);
  };

  return (
    <Grid container className={classes.space}>
      <Grid item xs={12}>
        <TextField
          label="User name"
          noMinHeight
          onChange={handleChange}
          size="small"
          error={userNameError !== ''}
          errorText={userNameError}
          autoFocus
          inputProps={{ 'data-testid': 'username' }}
        />
      </Grid>
    </Grid>
  );
};

export default SignUpFlowUsername;
